import {
  Mixins,
  Component,
  Prop,
  Watch,
} from 'vue-property-decorator';
import { ITABLECOLCONF } from '@/types/base.d';
import api from '@/api/user';
import pageMixin from '../../mixins/pageMixin';


@Component
export default class tableMixin extends Mixins(pageMixin) {
  @Prop({
    default: false,
  }) typeList!: any;

  private sList: any = [];

  public column: Array<ITABLECOLCONF> = [{
    label: '是否会员',
    prop: 'isVip',
    align: 'center',
    width: '90',
    custom: true,
    tags: [{
      value: '0',
      type: 'success',
      label: '是',
    }, {
      value: '1',
      type: 'warning',
      label: '否',
    }, {
      value: '2',
      type: 'success',
      label: '锁定',
    }, {
      value: 'null',
      type: 'info',
      label: '',
    }],
  }, {
    label: '账号',
    prop: 'userTitle',
    align: 'center',
  },
  {
    label: '姓名',
    prop: 'userName',
    align: 'center',
    tooltip: true,
  },
  {
    label: '状态',
    width: '100',
    prop: 'userStatus',
    align: 'center',
    custom: true,
    tags: [{
      value: '0',
      type: 'warning',
      label: '未激活',
    }, {
      value: '1',
      type: 'success',
      label: '激活',
    }, {
      value: '2',
      type: 'success',
      label: '锁定',
    }, {
      value: 'null',
      type: 'info',
      label: '',
    }],
  },
  {
    label: '头像',
    width: '120',
    align: 'center',
    prop: 'headImg',
    custom: true,
    icon: true,
  }, {
    label: '性别',
    width: '100',
    align: 'center',
    prop: 'userSex',
    custom: true,
    tags: [{
      value: '0',
      type: 'success',
      label: '女',
    }, {
      value: '1',
      type: 'success',
      label: '男',
    }, {
      value: '2',
      type: 'info',
      label: '未知',
    }, {
      value: 'null',
      type: 'info',
      label: '未知',
    }],
  }, {
    label: '学校名称',
    align: 'center',
    prop: 'schoolTitle',
  }, {
    label: '创建时间',
    prop: 'createTime',
    align: 'center',
  }, {
    label: '操作',
    custom: true,
    minWidth: '120',
    maxBtn: 2,
    btnList: [
      {
        title: '我的课程',
        name: '/userManage:check',
        icon: 'edit',
        type: 'info',
        callback: this.handleOpenCourse,
        log: {
          name: '系统配置 - 编辑',
          component: 'set/tableMixin',
        },
      },
      {
        title: '作品管理',
        name: '/userManage:manage',
        icon: 'edit',
        type: 'info',
        callback: this.handleUpdateForm,
        log: {
          name: '系统配置 - 编辑',
          component: 'set/tableMixin',
        },
      },
      {
        title: '重置密码',
        name: '/userManage:resetWord',
        icon: 'edit',
        type: 'info',
        callback: this.handleResetPwd,
        log: {
          name: '系统配置 - 编辑',
          component: 'set/tableMixin',
        },
      },
      {
        title: '锁定',
        name: '/userManage:lockWord',
        icon: 'edit',
        type: 'info',
        callback: this.handleStatus,
        log: {
          name: '系统配置 - 编辑',
          component: 'set/tableMixin',
        },
      },
    ],
    align: 'center',
  }];

  private loading: boolean = true;

  public difficulties: any = [];

  mounted() {
    this.getData();
  }

  handleOpenCourse(row: any) {
    api.getCourseById(row.pid).then((res: any) => {
      if (res.length === 0) {
        this.msg('该用户暂无课程', 'warning');
      } else {
        this.$router.push({ name: 'userManage/myCourse', params: { pid: row.pid } });
      }
    });
  }

  /* eslint-disable class-methods-use-this */
  handleUpdateForm(row: any) {
    this.$router.push({ name: 'userManage/workManage', params: { pid: row.pid, row: row } });
  }

  /**
   * @author niuhong
   * @desc 获取用户配置列表
   */
  getData(title?: string) {
    this.loading = true;
    api.getUser(this.page, 1, title || '').then((res: any) => {
      this.sList = res.content;
      this.total = res.totalElements;
      this.loading = false;
    });
  }

  handleResetPwd(row: any) {
    this.confirm('你确定为该用户重置密码吗?', {
      title: '警告',
      loading: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      iconType: 'warning',
    }).then((close: Function) => {
      api.resetPass(row.pid).then(() => {
        close();
        this.$log({
          title: '机构管理 - 重置密码 - 确定',
          component: 'org/manage/tableMixin',
        });
      }).catch(() => close());
    }).catch(() => this.$log({
      title: '机构管理 - 重置密码 - 取消',
      component: 'org/manage/tableMixin',
    }));
  }

  handleStatus(row: any) {
    this.confirm('你确定要锁定该账号吗?', {
      title: '警告',
      loading: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      iconType: 'warning',
    }).then((close: Function) => {
      api.editStatus(row.pid, 2).then(() => {
        close();
        this.$log({
          title: '机构管理 - 重置密码 - 确定',
          component: 'org/manage/tableMixin',
        });
      }).catch(() => close());
    }).catch(() => this.$log({
      title: '机构管理 - 重置密码 - 取消',
      component: 'org/manage/tableMixin',
    }));
  }
}
